export function formatGamertag(gamertag, suffix) {
    return suffix != null ? `${gamertag}#${suffix}` : gamertag;
}
export function normalizeGamertag(gamertag) {
    return gamertag.toLowerCase().replace(/[\s_-]/g, '');
}
export function validateGamertag(gamertag) {
    if (gamertag.length < 3 || gamertag.length > 30) {
        return { ok: false, reason: 'Gamertag must be 3-30 characters' };
    }
    if (gamertag !== gamertag.trim()) {
        return { ok: false, reason: 'No leading or trailing whitespace' };
    }
    if (/ {2}/.test(gamertag)) {
        return { ok: false, reason: 'No consecutive spaces' };
    }
    if (!/^[a-zA-Z0-9 _#-]+$/.test(gamertag)) {
        return {
            ok: false,
            reason: 'Only letters, numbers, spaces, hyphens, underscores, and # allowed',
        };
    }
    if (!/[a-zA-Z]/.test(gamertag)) {
        return { ok: false, reason: 'Must contain at least one letter' };
    }
    return { ok: true };
}
//# sourceMappingURL=gamertag.js.map